<template>
  <div>
    <b-container class="p-0">
      <b-row>
        <b-col lg="12" md="12" sm="12">
              <div class="column-title mb-4">Dados do cliente</div>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(reservar)">
              <b-row v-if="!isLoading">
                <b-col cols="12">
                  <base-input
                    ref="nameInput"
                    v-model="form.name"
                    placeholder="Insira seu nome completo"
                    label="Nome *"
                    prepend-icon="ni ni-single-02"
                    alternative
                    class="mb-3"
                    labelClasses="form-control-label"
                    name="nome"
                    :rules="{ required: true, min: 3 }"
                  >
                  </base-input>
                </b-col>

                <b-col
                  v-if="!isLoading && showFields && form.cpf_cnpj.length <= 14"
                  cols="12"
                >
                  <base-input
                    v-model="form.surname"
                    placeholder="Sobrenome"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-single-02"
                    label="Sobrenome"
                    labelClasses="form-control-label"
                    name="sobrenome"
                  >
                  </base-input>
                </b-col>

                <b-skeleton
                  v-if="isLoading"
                  animation="wave"
                  type="input"
                ></b-skeleton>
              </b-row>

              <b-row>
                <b-col cols="4">
                  <b-form-group
                    v-if="!isLoading"
                    label="País *"
                  >
                    <b-form-select v-model="form.phoneFlag">
                      <template #first>
                        <b-form-select-option value="" disabled
                          >Escolha o país</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(flag, idx) in dialCodesArray"
                        :value="flag.dialcode"
                        :key="idx"
                      >
                        {{ getFlagEmoji(flag.iso) + ' ' + flag.name }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-skeleton
                    v-else
                    animation="wave"
                    type="input"
                    width="80%"
                  ></b-skeleton>
                </b-col>

                <b-col cols="8">
                  <base-input
                    v-if="!isLoading"
                    v-model="form.phone"
                    v-mask="'(##) #####-####'"
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-phone"
                    placeholder="Telefone"
                    name="telefone"
                    label="Telefone *"
                    labelClasses="form-control-label"
                    :rules="{ required: true, min: 14 }"
                  >
                    <template #prepend>
                      {{ '+' + form.phoneFlag }}
                    </template>
                  </base-input>

                  <b-skeleton v-else animation="wave" type="input"></b-skeleton>
                </b-col>
              </b-row>

              

              <b-row v-if="showFields">
                <b-col sm="12" md="6" lg="6">
                  <base-input
                    v-model="form.address.street"
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-address-card"
                    placeholder="Rua, Avenida..."
                    name="endereco"
                    label="Endereço"
                    labelClasses="form-control-label"
                    :rules="{ required: true }"
                  >
                  </base-input>
                </b-col>

                <b-col sm="12" md="6" lg="6">
                  <base-input
                    v-model="form.address.complement"
                    alternative
                    class="mb-3"
                    placeholder="Apartamento, conjunto, sala..."
                    name="complemento"
                    label="Complemento"
                    labelClasses="form-control-label"
                    :rules="{ required: true }"
                  >
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="showFields">
                <b-col sm="12" md="4" lg="4">
                  <base-input
                    v-model="form.address.zipcode"
                    alternative
                    class="mb-3"
                    placeholder="CEP"
                    name="cep"
                    label="CEP"
                    labelClasses="form-control-label"
                    v-mask="['#####-###']"
                    :rules="{ required: true }"
                  >
                  </base-input>
                </b-col>

                <b-col sm="12" md="4" lg="4">
                  <base-input
                    v-model="form.address.neighborhood"
                    alternative
                    class="mb-3"
                    placeholder="Bairro da residência"
                    name="bairro"
                    label="Bairro"
                    labelClasses="form-control-label"
                    :rules="{ required: true }"
                  >
                  </base-input>
                </b-col>

                <b-col sm="12" md="4" lg="4">
                  <base-input
                    v-model="form.address.number"
                    alternative
                    class="mb-3"
                    placeholder="Número da residência"
                    name="número"
                    label="Número"
                    labelClasses="form-control-label"
                    :rules="{ required: true }"
                  >
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="showFields">
                <b-col cols="12">
                  <b-form-group label="País">
                    <b-form-select
                      v-model="form.address.country"
                      class="mb-3"
                      :rules="{ required: true }"
                    >
                      <template #first>
                        <b-form-select-option value="" disabled
                          >País de residência</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(country, idx) in countries"
                        :value="country[0]"
                        :key="idx"
                      >
                        {{ country[1] }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row
                v-if="showFields && form.address.country == '1'"
              
              >
                <b-col sm="12" md="6" lg="6">
                  <b-form-group label="Estado">
                    <b-form-select v-model="form.address.state" class="mb-3">
                      <template #first>
                        <b-form-select-option value="" disabled
                          >Estado</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(state, idx) in states"
                        :value="state[0]"
                        :key="idx"
                      >
                        {{ state[2] }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="6" lg="6">
                  <b-form-group label="Cidade">
                    <b-form-select v-model="form.address.city" class="mb-3">
                      <template #first>
                        <b-form-select-option value="" disabled
                          >Cidade</b-form-select-option
                        >
                      </template>

                      <b-form-select-option
                        v-for="(city, idx) in cities"
                        :value="city[0]"
                        :key="idx"
                      >
                        {{ city[1] }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row >

                <b-col
                  v-if="identityRequiredTickets(form.atrativo.uuid).length > 0 && !form.payLater"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <base-input
                    v-model="form.cpf_cnpj"
                    v-mask="getDocMask(form.cpf_cnpj)"
                    maxlength="18"
                    placeholder="CPF, CNPJ ou Passaporte"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    type="text"
                    name="documento"
                    label="Documento (CPF/CNPJ/Passaporte) *"
                    labelClasses="form-control-label"
                    :rules="{ required: true }"
                    @keyup="upperCaseDoc($event, 'cpf_cnpj')"
                  >
                  </base-input>
                </b-col>
                <b-col
                  :cols="
                    identityRequiredTickets(form.atrativo.uuid).length > 0
                      ? (isMobile ? 12 : 6)
                      : 12
                  "
                >
                  <base-input
                    v-model="form.email"
                    placeholder="Insira seu e-mail"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    type="email"
                    name="email"
                    label="Email"
                    labelClasses="form-control-label"
                    :rules="{ required: false }"
                  >
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="!showFields">
                <b-col cols="6">
                  <base-input
                    v-model="form.hash"
                    alternative
                    class="mb-3"
                    placeholder="Hash"
                    name="Hash"
                    label="Hash"
                    labelClasses="form-control-label"
                    hidden
                  >
                  </base-input>
                </b-col>
              </b-row>

              <!-- <h3 class="d-block mt-3">Termos e condições *</h3> -->
              <div class="d-flex mt-2" align-h="start">
                <div>
                  <b-form-checkbox
                    v-model="form.confirm_term"
                    :value="true"
                    :unchecked-value="false"
                    :disabled="disabledTermCheckbox"
                    @change="toggleTermSign($event)"
                    :rules="{ required: true }"
                  >
                  </b-form-checkbox>
                </div>

                <div>
                  <span>
                    Declaro que li e aceito os
                    <span @click="openModalTerm" class="text-button"
                      >Termos e Condições</span
                    >
                  </span>
                </div>
              </div>

              <div
                id="payment details"
                v-show="!form.free_booking && !form.payLater"
              >
              <div class="column-title mb-3 mt-5">Forma de pagamento</div>
                <div class="pl-3 form-group">
                  <b-form-group label="">
                    <b-form-radio-group
                      id="payment_method"
                      v-model="paymentMethod"
                      :options="
                        paymentMethods.filter((pm) => pm.active == true)
                      "
                      name="cod-options"
                      stacked
                      @change="setPaymentMethod"
                    >
                    </b-form-radio-group>
                    <!-- i :class="`${disablePayLater() ? 'text-warning' : 'text-info'} no no-c-info`" :title="disablePayLater(true)"></i -->
                  </b-form-group>
                </div>
              </div>

              <div v-if="isAgent" class="d-flex mt-2" align-h="start">
                <div>
                  <b-form-checkbox
                    v-model="form.hasAgent"
                    :unchecked-value="false"
                  >
                  </b-form-checkbox>
                </div>

                <div>
                  <span> Assumir guiada </span>
                </div>
              </div>

              <div class="mt-2" v-show="false" align-h="start">
                <div>
                  <b-form-checkbox
                    v-model="form.payLater"
                    :value="true"
                    :unchecked-value="false"
                    :rules="{ required: true }"
                    :disabled="disablePayLater()"
                  >
                  </b-form-checkbox>
                </div>

                <div>
                  <span> Pago no local </span>
                </div>
              </div>
            </b-form>

            <b-navbar class="floating-buttons" style="background-color: #fff">
              <b-navbar-nav>
                <b-button
                  @click="prev()"
                  variant="primary"
                  class="mt-0 rounded-pill"
                  style="padding-top: 7px; padding-bottom: 7px"
                  >Voltar</b-button
                >
              </b-navbar-nav>

              <b-navbar-nav>
                <b-button
                  @click="askResetForm()"
                  variant="danger"
                  class="mt-0 rounded-pill"
                  style="padding-top: 7px; padding-bottom: 7px"
                  >Cancelar</b-button
                >
              </b-navbar-nav>
              <b-navbar-nav>
                <b-button
                  @click="checkPaymentMethod()"
                  :disabled="disableNextButton()"
                  type="submit"
                  variant="success"
                  class="mt-0 rounded-pill"
                  style="
                    background-color: #22a06b;
                    border-color: #22a06b;
                    padding-top: 7px;
                    padding-bottom: 7px;
                  "
                >
                  {{
                    form.payLater
                      ? 'Avançar'
                      : calculateTotalCost() > 0 &&
                        !form.payLater &&
                        !form.payment_method == 'set_cod'
                      ? 'Pagar online'
                      : 'Reservar'
                  }}
                </b-button>
              </b-navbar-nav>
            </b-navbar>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      v-if="isModalTermsOpen"
      v-model="isModalTermsOpen"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      modal-class="fullheight-modal"
      hide-header
      hide-footer
    >
      <booking-term
        @close="closeModalTerm"
        @sign="acceptTerms"
        :items="form.tickets"
        :showHeader="true"
        :showFooter="true"
        :enable-signature-footer="false"
        :place_uuid="form.atrativo.product_place"
        :product_uuid="form.atrativo.uuid"
      />
    </b-modal>

    <PagamentoModal
      v-if="isModalPagamentoOpen"
      :isPaymentLater="form.payLater"
      @closePagamentoModal="closePagamentoModal"
      :PAYMENT_STATUS="PAYMENT_STATUS"
      :isModalPagamentoOpen="isModalPagamentoOpen"
    >
    </PagamentoModal>

    <!-- MODAL LOCAL PAYMENT -->
    <LocalPaymentModal
      v-if="isModalPagamentoLocalOpen"
      :PAYMENT_STATUS="'UNPAID'"
      :isPaymentLater="form.payLater"
      @closePagamentoModal="closeModalPagamentoLocal"
      @confirmLocalPayment="confirmLocalPayment"
    >
    </LocalPaymentModal>
    <!-- END MODAL LOCAL PAYMENT -->
  </div>
</template>

<script>
import _ from 'lodash'
import { isMobile } from '@/store/utils/general'
import swal from 'sweetalert2'
import { hasModule } from '../../store/utils/users'
import { isReservationManager } from '@/store/utils/reservationManager'
import nodeService from '@/services/nodejs'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { VueMaskDirective } from 'v-mask'
import { v4 as uuidv4 } from 'uuid'
import PagamentoModal from './PagamentoModal.vue'
import LocalPaymentModal from '../ReservaExpressa/LocalPaymentModal.vue'
import BookingTerm from './BookingTerm.vue'
import useManageReservaExpressaInjection from '../../Composables/useManageReservaExpressa'

export default {
  name: 'DadosForm',

  setup(props, context) {
    const manageReservaExpressa = useManageReservaExpressaInjection(context)

    function calculateTotalCost() {
      return manageReservaExpressa.calculateTotalCost()
    }
    function setTickets(items) {
      return manageReservaExpressa.setTickets(items)
    }

    return {
      calculateTotalCost,
      setTickets,
    }
  },

  directives: { mask: VueMaskDirective },

  components: {
    PagamentoModal,
    LocalPaymentModal,
    BookingTerm,
  },

  inject: ['isOnline'],

  props: {
    PAYMENT_STATUS: {
      type: String,
      default: '' | null,
    },

    AUTO_CHECKIN: {
      type: Boolean,
      default: false,
    },
    poisList: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      isMobile: isMobile(),
      showFields: false,
      isLoading: true,
      isModalResumoOpen: false,
      isModalPagamentoOpen: false,
      isModalPagamentoLocalOpen: false,
      isModalTermsOpen: false,
      paymentMethod: 'pix',
      paymentMethods: [
        {
          value: 'pix',
          text: 'QRCode PIX',
          msg: 'Será gerado um QRCode pix para pagamento em até 10min após ser gerado',
          selected: false,
          active: true,
        },
        {
          value: 'cod',
          text: `Pagar depois`,
          msg: 'Você poderá pagar a reserva no local (Crédito, Débito) ou via link de pagamento que será disponibilizado',
          selected: false,
          active: false,
        },
        {
          value: 'set_cod',
          text: 'Marcar como paga',
          msg: 'Informe os detalhes dos valores já recebinos',
          selected: false,
          active: false, //enabled in mounted method when bookings_admin module is enabled
        },
      ],
      handle_my_place_agents: false,
    }
  },

  watch: {
    isLoading(val) {
      if (!val) {
        this.$nextTick(() => {
          this.focusNameInput()
        })
      }
    },

    PAYMENT_STATUS(newValue, oldValue) {
      if (newValue == null) {
        this.resetFormData()
      }
    },

    ['form.payLater'](newValue, oldValue) {
      if (newValue) {
        this.form.hash = uuidv4().toUpperCase()
      }
    },

    ['form.tickets'](newValue, oldValue) {
      this.setTickets(newValue)
    },

    ['form.date'](newValue, oldValue) {
      this.updatePaylaterLabel()
    },

    ['form.address.country'](newValue, oldValue) {
      if (newValue != undefined && newValue != '' && newValue.length > 0) {
        this.form.address.state = ''
        this.form.address.city = ''
        this.bookingStoreCommit({
          mutation: 'SET_RESERVA_FORM',
          value: this.form,
        })
        this.loadStates()
      }
    },

    ['form.address.state'](newValue, oldValue) {
      if (newValue != undefined && newValue != '' && newValue.length > 0) {
        this.form.address.city = ''
        this.bookingStoreCommit({
          mutation: 'SET_RESERVA_FORM',
          value: this.form,
        })
        this.loadCities()
      }
    },

    poisList(newValue, oldValue) {
      this.paymentMethods.map((pm) => {
        if (pm.value == 'cod') {
          if (this.isUserAuthorizedToPayLater || this.form.payLater) {
            pm.active = true
          }
        } else if (pm.value == 'set_cod') {
          if (this.isUserAuthorizedToPayLater) {
            pm.active = true
          }
        }
      })
      this.syncPixOption()
      this.updatePaylaterLabel()
    },

    'form.atrativo'() {
      this.syncPixOption()
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
      dialCodesArray: 'getDialCodesArray',
      countries: 'getCountriesArray',
      states: 'getStatesArray',
      cities: 'getCitiesArray',
      expressBookingResponse: 'getExpressBookingResponse',
    }),
    ...mapGetters('operacao', {
      bookingDetails: 'getBookingDetails',
    }),

    ...mapGetters('auth', {
      user: 'user',
      params: 'params',
    }),

    isAgent() {
      return this.user.isAgent ? this.user.isAgent : null
    },

    isUserAuthorizedToPayLater() {
      return isReservationManager({
        params: this.params,
        user: this.user,
        poisList: this.poisList,
        atrativo: this.form.atrativo,
      })
    },

    disabledButton() {
      return this.form.name.length == 0 ||
        this.form.name.length < 2 ||
        !this.isOnline ||
        !this.form.confirm_term ||
        this.form.phone.length == 0 ||
        this.form.phone.length < 14
        ? true
        : false
    },

    disabledTermCheckbox() {
      return this.form.name.length == 0 ||
        (
          this.identityRequiredTickets().length > 0 &&
          !this.form.payLater &&
          !this.isCompleteIdentityDoc(this.form.cpf_cnpj)
        ) ||
        !this.isOnline ||
        this.form.phone.length < 14
        ? true
        : false
    },

    totalCost() {
      const totalCost = this.calculateTotalCost()
      if (totalCost <= 0) {
        // this.form.payLater = false
      }
      return totalCost
    },

    ticketsSummary() {
      var vm = this
      return Object.values(this.form.tickets)
        .map(function (val, idx) {
          var quantity = Number(val.quantity)
          var price =
            val.price != null && val.price != undefined
              ? parseFloat(val.price.replace(/[^0-9.]/g, '.'))
              : 0

          if (quantity > 0) {
            return {
              name:
                val.booking_name != null &&
                val.booking_name != undefined &&
                val.booking_name.length > 0
                  ? val.booking_name
                  : val.label,
              description: vm.form.booking_name + '-' + val.label,
              value: Number(price.toFixed(2)),
              quantity: parseInt(val.quantity),
              sku: '',
            }
          }
        })
        .filter((i) => i != undefined)
    },
  },

  methods: {
    ...mapActions('booking', [
      'createExpressBooking',
      'bookingStoreCommit',
      'fetchDialCodes',
      'fetchCountries',
      'fetchStates',
      'fetchCities',
    ]),

    ...mapActions('operacao', ['fetchBookingByUUID']),

    getDocMask(value) {
      const doc = String(value || '')
      if (/[A-Za-z]/.test(doc)) return 'AA######'
      const digits = doc.replace(/\D/g, '')
      if (digits.length > 11) return '##.###.###/####-##'
      return '###.###.###-##'
    },

    isCompleteIdentityDoc(doc) {
      const value = String(doc || '').trim()
      if (/[A-Za-z]/.test(value)) {
        return /^[A-Za-z]{2}[0-9]{6}$/.test(value)
      }
      const digits = value.replace(/\D/g, '')
      return digits.length === 11 || digits.length === 14
    },

    upperCaseDoc(event, field) {
      const upper = String(event.target.value || '').toUpperCase()
      if (field === 'cpf_cnpj') {
        this.form.cpf_cnpj = upper
      }
    },

    toggleTermSign(checked) {
      if (checked) {
        if (
          this.identityRequiredTickets(this.form.atrativo.uuid).length > 0 &&
          !(this.form.cod_booking == false && this.form.payLater == true)
        ) {
          this.openModalTerm()
          this.form.confirm_term = false
        }
      }
      return true
    },
    identityRequiredTickets(uuid) {
      if (!uuid) {
        uuid = this.form.atrativo.uuid
      }
      const poiIndex = this.poisList.findIndex((p) => p.uuid == uuid)
      const valid_tickets = this.form.tickets.filter(
        (ticket) => ticket.quantity > 0
      )
      if (poiIndex == -1) {
        return []
      }

      const identity_required_tickets = Object.values(
        this.poisList[poiIndex].tickets
      ).filter(
        (ticket) =>
          ticket.identity_required &&
          valid_tickets.find((t) => t.id == ticket.id)
      )
      return identity_required_tickets
    },

    setPaymentMethod(value) {
      this.form.cod_booking = value == 'set_cod'
    },

    // xfield active do produto fica em form.atrativo.active. Falso tira o PIX.
    syncPixOption() {
      const atrativo = this.form && this.form.atrativo
      const pixOff = !!(atrativo && atrativo.active == false)
      const pix = this.paymentMethods.find((pm) => pm.value == 'pix')
      if (!pix) return
      pix.active = !pixOff
      if (!pixOff || this.paymentMethod != 'pix') return
      const next = this.paymentMethods.find(
        (pm) => pm.active && pm.value != 'pix'
      )
      this.paymentMethod = next ? next.value : ''
      this.setPaymentMethod(this.paymentMethod)
    },

    prev() {
      this.form.confirm_term = false
      this.$emit('goToSection', 'ingressos')
    },

    focusNameInput() {
      const nameInput = this.$refs.nameInput
      if (!nameInput) return

      const inputEl =
        nameInput.$el && typeof nameInput.$el.querySelector === 'function'
          ? nameInput.$el.querySelector('input, textarea')
          : nameInput

      if (inputEl && typeof inputEl.focus === 'function') {
        inputEl.focus()
      }
    },

    disableNextButton() {
      // Acrescentar this.totalCost == 0 na condição para impedir compra de somente cortesia
      if (this.disabledButton) {
        return true
      } else {
        return false
      }
    },
    disablePayLater(returnMsg) {
      // return false
      let msg =
        'a reserva poderá ser paga no local ou via link de pagamento disponível nos detalhes da reserva'

      const days_in_advance = this.form.atrativo.special_prices
        ? this.form.atrativo.special_prices[0].find(
            (ticket) => ticket.slug == this.form.booking_slug
          ).days_in_advance
        : 0
      let form_date = moment(this.form.date + ' ' + this.form.time).format(
        'YYYY-MM-DD hh:mm'
      )
      let subtracted = moment(form_date).subtract(days_in_advance, 'days')
      // let subtractedIsBefore = subtracted.isBefore(moment())
      let disabled = false

      if (this.totalCost == 0) {
        disabled = true
        msg = 'reservas gratúitas não podem ter pagamento agendado'
      }

      if (disabled) {
        // this.form.payLater = false
      }

      if (returnMsg) {
        return msg
      }

      return disabled
    },

    askResetForm() {
      swal
        .fire({
          text: 'Cancelar compra?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, cancelar',
          confirmButtonClass: 'btn btn-warning',
          confirmButtonColor: '#DD6B55',
          cancelButtonText: 'Continuar comprando',
          reverseButtons: true,
          cancelButtonColor: 'primary',
          type: 'warning',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.resetFormData()
            if (window.parent && window.parent !== window) {
              this.$emit('goToSection', 'atrativos')
              return
            }
            this.$emit('goToSection', 'ingressos')
          }
        })
    },

    resetFormData() {
      this.$emit('resetPaymentStatus', null)
      this.bookingStoreCommit({
        mutation: 'RESET_FORM_STANDART_DATA',
        value: this.form,
      })
      this.bookingStoreCommit({
        mutation: 'SET_RESERVA_FORM',
        value: this.form,
      })
    },

    loadDialCodes() {
      this.fetchDialCodes()
    },
    loadCountries() {
      this.fetchCountries()
    },
    loadStates() {
      this.fetchStates(this.form.address.country)
    },
    loadCities() {
      this.fetchCities(this.form.address.state)
    },

    getFlagEmoji(countryCode) {
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt())
      return String.fromCodePoint(...codePoints)
    },

    openModalTerm() {
      this.isModalTermsOpen = true
    },

    closeModalTerm() {
      this.isModalTermsOpen = false
    },

    isExpressBookingComplete(response) {
      if (!response) return false

      if (typeof response === 'string') {
        return response.trim().length > 0
      }

      if (typeof response === 'object') {
        return Boolean(
          response.description ||
            response.additional_data ||
            response.hash ||
            response.booking_code
        )
      }

      return false
    },

    async waitForExpressBooking(timeoutMs = 600000) {
      if (this.isExpressBookingComplete(this.expressBookingResponse)) {
        return Promise.resolve(this.expressBookingResponse)
      }

      return new Promise((resolve, reject) => {
        const unwatch = this.$watch('expressBookingResponse', (response) => {
          if (!this.isExpressBookingComplete(response)) return
          clearTimeout(timeoutId)
          unwatch()
          resolve(response)
        })

        const timeoutId = setTimeout(() => {
          unwatch()
          reject(new Error('A reserva não foi concluída a tempo.'))
        }, timeoutMs)
      })
    },

    async acceptTerms(payload) {
      if (!payload || !payload.requiredTickets) {
        this.form.confirm_term = true
        this.isModalTermsOpen = false

        return
      }
      try {
        this.form.confirm_term = true
        this.isModalTermsOpen = false
        await this.waitForExpressBooking()
        let code = null
        let bookingHash = null
        if (typeof this.expressBookingResponse == 'string') {
          code = this.expressBookingResponse.split('code')[1].trim()
          await this.fetchBookingByUUID(code)
          if (this.bookingDetails.length > 0) {
            bookingHash = this.bookingDetails[0].payload.term.hash
          }
          if (!code || !bookingHash) {
            this.$notify({
              message: 'Não foi possível obter o código da reserva.',
              duration: 5000,
              type: 'error',
            })
            return
          }
          await nodeService.saveTermSignatures(payload)
          this.$notify({
            message: 'Assinatura do termo registrada.',
            duration: 4000,
            type: 'success',
          })
        } else {
          // console.warn(
          //   'pix... aguardando o pagamento',
          //   this.expressBookingResponse
          // )
        }
      } catch (error) {
        this.$notify({
          message:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            'Não foi possível salvar a assinatura do termo.',
          duration: 5000,
          type: 'error',
        })
      }
      this.form.confirm_term = true
      this.isModalTermsOpen = false
    },

    checkPaymentMethod() {
      if (this.disabledButton) {
        this.reservar()
      } else {
        if (this.paymentMethod == 'set_cod') {
          this.isModalPagamentoLocalOpen = true
        } else {
          this.reservar()
        }
      }
    },

    reservar(localPayments) {
      if (this.disabledButton) {
        var message = ''
        if (this.form.name.length == 0 || this.form.name.length < 2) {
          message = 'Preencha o campo Nome do formulário.'
        }
        if (this.form.phone.length == 0 || this.form.phone.length < 14) {
          message = 'Preencha o campo Telefone do formulário.'
        }
        if (!this.form.confirm_term) {
          message =
            'É necessário aceitar os Termos e Condições para prosseguir.'
          this.openModalTerm()
        }
        if (!this.isOnline) {
          message = 'Dispositivo offline!'
        }

        this.$notify({
          message: message,
          duration: 5000,
          type: 'warning',
          overlap: false,
        })
      } else {
        this.form.gateway = 'EXPRESSBOOKING'
        this.isModalPagamentoOpen = true
        this.form.payment_method = this.paymentMethod
        this.form.localPayments = localPayments
        this.form.payLater =
          this.form.cod_booking || this.paymentMethod == 'cod'
        this.createExpressBooking(this.form)
      }
    },

    updatePaylaterLabel() {
      let weekday = new Date(this.form.date + ' ' + this.form.time)
        .toLocaleDateString('en', { weekday: 'long' })
        .toLowerCase()
      let end = '00:00'
      if (this.form.atrativo.availability[weekday] != undefined) {
        let end = this.form.atrativo.availability[weekday].find(
          (block) => block.start == this.form.time
        )
        if (end) {
          end = end.end
        }
      }

      if (this.form.free_booking) {
        this.paymentMethods.map((pm) => {
          pm.value == 'pix' ? (pm.text = `gratuito`) : ''
        })
      }

      this.paymentMethods.map((pm) => {
        pm.value == 'cod' ? (pm.text = 'Pagar depois') : ''
      })
    },
    closePagamentoModal() {
      this.isModalPagamentoOpen = false
    },

    getUserId() {
      return this.user.id ? this.user.id : null
    },

    closeModalPagamentoLocal() {
      this.isModalPagamentoLocalOpen = false
    },

    confirmLocalPayment(localPayments) {
      this.isModalPagamentoLocalOpen = false
      this.isLoading = true
      this.reservar(localPayments)
    },
  },

  async created() {
    await this.form
    // this.form.payLater = true
    if (process.env.NODE_ENV != 'production') {
      this.todayReferenceDate = moment().format('YYYY-MM-DD')
      window.jdebug = this
    }
    this.loadDialCodes()
    this.isLoading = false
  },
  async mounted() {
    if (
      process.env.NODE_ENV !== 'production' ||
      this.$route.query.debug == 'true'
    ) {
      window.jdebug = this
    }
    if (this.isUserAuthorizedToPayLater) {
      this.paymentMethods.map((pm) => {
        if (pm.value == 'set_cod') {
          pm.active = true
        }
      })
    }
    await this.setPaymentMethod('pix')
    this.handle_my_place_agents = hasModule('handle_my_place_agents')
    this.form.auto_checkin = this.AUTO_CHECKIN
    this.setTickets(this.form.tickets)
    this.loadCountries()
    this.loadStates()
    this.updatePaylaterLabel()
    this.paymentMethod = this.form.payLater ? 'cod' : 'pix'
    this.syncPixOption()

    this.$nextTick(() => {
      this.focusNameInput()
    })
    if (
      this.identityRequiredTickets(this.form.atrativo.uuid).length > 0 &&
      this.form.cpf_cnpj == '012.345.678-90'
    ) {
      this.form.cpf_cnpj = ''
    }
  },
}
</script>
<style>
.form-control-label{
  font-size: .9em;
  font-weight: normal;
}
</style>
<style scoped>
.floating-buttons {
  width: 400px;
  height: auto;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px 12px 0 0px;
  padding: 15px;
  z-index: 999;
  position: fixed;
  bottom: 0;
  left: 50%;
  justify-content: space-between;
  transform: translateX(-50%);
}

@media screen and (max-width: 980px) {
  .floating-buttons {
    width: 400px;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px 12px 0 0px;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    padding-bottom: 25px;
    left: 38%;
    justify-content: space-between;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 870px) {
  .floating-buttons {
    width: 100%;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    padding-bottom: 25px;
    left: 50%;
    justify-content: space-between;
    transform: translateX(-50%);
  }
}

.custom-select {
  padding-right: 2.75rem;
}

.click-check {
  pointer-events: none;
  cursor: default;
}

.text-button {
  color: #a7aa37;
  text-decoration: underline;
  cursor: pointer;
}
</style>
